import React, { Component } from "react";
import ReactDOM from 'react-dom';
import Grid from '@material-ui/core/Grid'
import { ProgressBar, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import LockIcon from '@material-ui/icons/Lock';
import '../../App.css';
import './Cards.css'
import ModalBox from '../../Components/Modal'
// images
import logoimg from '../../img/busdlogo.png'
import Lock from '../../img/lockicon.png'



const Cards = (props) => {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const percentage = 100;
  const percentage1 = 34;
  const percentage2 = 11;
  return (
    <Grid
      container
      direction="column"
      justify="flex-start"
      xs={12}
      className="pcc---buyCard my-3"
    >
      <button className="pcc---buyCardBoxs px-2 px-md-4 py-4" type="button" onClick={handleOpen}>

        <Grid
          container
          direction="row"
          justify="flex-start"
          xs={12}
          className="pcc---buyCard"
        >
          <Grid
            container
            direction="column"
            justify="flex-start"
            xs={12}
            sm={6}
            className="pcc---buyCard"
          >
            {/* <div className="text-left"> */}
              <h2 className="mb-0" style={{textAlign:'left',padding:'0px',border:'none',fontSize: '30px',display: "block"}}>
                <img src={logoimg} style={{height:"100%",width:'auto',maxHeight:32,marginRight: 5}}/><strong>BUSD</strong>
              </h2>
            {/* </div> */}
            <p className="mb-0 mt-md-2 text-left">#no 1 BUSD Token</p>
            <p className="mb-0 text-left">PancakeswapV2 index 0</p>
          </Grid>
          <Grid
            container
            direction="column"
            justify="flex-start"
            xs={12}
            sm={6}
            className="pcc---buyCard"
          >
          <div className="text-right">
            <h2 className="ml-1 mt-2 mb-0" style={{padding:'0px',border:'none',fontSize: '25px'}}><strong>$1</strong></h2>
          </div>
          <p className="mb-0 mt-md-2 text-right">vol: <strong>$89.91M</strong></p>
          <p className="mb-0 text-right">dmcap: <strong> $4.1B</strong></p>
        
          </Grid>             
        </Grid>
        <Grid
          container
          direction="row"
          justify="flex-start"
          xs={12}
          className="pcc---buyCard"
        >
          <Grid
            container
            direction="column"
            justify="flex-start"
            xs={12}
            sm={3}
            className="pcc---buyCard"
          >
            <div className="mt-md-3 text-left mb-1" style={{padding:'0px',border:'none',fontSize: '18px',color:'#fdb134'}} >
              <LockIcon style={{width:' 11%',marginTop:'-6px'}}/><strong className="ml-1 d-inline-block">$454K</strong>
            </div>
          </Grid>
          <Grid
            container
            direction="column"
            justify="flex-start"
            xs={12}
            sm={3}
            className="pcc---buyCard mt-3 pr-md-1"
          
          >
            <h6 className="text-md-left" style={{color:'#cdcdcd',fontSize:14}}>30d:<span style={{color:'#28a745'}}><strong>{percentage}%</strong></span></h6>
            <ProgressBar variant="success" now={percentage}/>
          </Grid>
          <Grid
            container
            direction="column"
            justify="flex-start"
            xs={12}
            sm={3}
            className="pcc---buyCard mt-3 px-md-1"
          >
            <h6 style={{color:'#cdcdcd',fontSize:14}}>7d:<span style={{color:'#dc3545'}}><strong>{percentage1}%</strong></span></h6>
            <ProgressBar variant="danger" now={percentage1}/>
          </Grid>
          <Grid
            container
            direction="column"
            justify="flex-start"
            xs={12}
            sm={3}
            className="pcc---buyCard mt-3 pl-md-1"
          >
            <h6 className="text-md-right" style={{color:'#cdcdcd',fontSize:14}}>1d:<span style={{color:'#dc3545'}}><strong>{percentage2}%</strong></span></h6>
            <ProgressBar variant="danger" now={percentage2}/>
          </Grid>
        </Grid>
      </button> 
      <ModalBox 
        open={open}
        handleClose={handleClose}
      /> 
    </Grid>
  );
}

export default Cards;



